/* eslint-disable dot-notation */
import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import styles from './Switcher.module.scss';

const noOp = () => {};

const Switcher = ({
  renderLeftIcon,
  renderRightIcon,
  dataTest = '',
  onClickLeft = noOp,
  onClickRight = noOp,
  isPositionRight = false
}) => {
  const [isRightActive, setIsRightActive] = useState(false);

  const toggleIsRight = () => {
    setIsRightActive(!isRightActive);
    if (isRightActive) {
      onClickLeft();
    } else {
      onClickRight();
    }
  };

  useEffect(() => {
    setIsRightActive(isPositionRight);
  }, [isPositionRight, setIsRightActive]);

  const ballStyles = classNames(styles['switcher__ball'], {
    [styles['switcher__ball--right']]: isRightActive
  });

  const switcherIconStyles = classNames(styles['switcher__icon'], {
    [styles['switcher__icon--left']]: !isRightActive,
    [styles['switcher__icon--right']]: isRightActive
  });

  return (
    <div
      className={styles['switcher']}
      onClick={toggleIsRight}
      role="button"
      tabIndex={0}
      data-test={dataTest}
    >
      <span className={ballStyles} />
      <div className={styles['switcher__overlay']}>
        <span className={switcherIconStyles}>{renderLeftIcon()}</span>
        <span className={switcherIconStyles}>{renderRightIcon()}</span>
      </div>
    </div>
  );
};

Switcher.propTypes = {
  renderLeftIcon: PropTypes.func.isRequired,
  renderRightIcon: PropTypes.func.isRequired,
  dataTest: PropTypes.string,
  onClickLeft: PropTypes.func,
  onClickRight: PropTypes.func,
  isPositionRight: PropTypes.bool
};

export default Switcher;
